import React from "react";
import { Tree, TreeNode } from "react-organizational-chart";
import "./styles/hirerichy.css";

const Hierarchy = () => {
  return (
    <div className="hierarchy-container">
      <Tree
        lineWidth={"2px"}
        lineColor={"#01c5ff"}
        lineBorderRadius={"10px"}
        label={<div className="node parent">Employee Benefits</div>}
        className="horizontal-tree"
      >
        <TreeNode label={<div className="node">Competitive Pay</div>}>
          <TreeNode label={<div className="node">Health & Wellness</div>}>
            {/* <TreeNode label={<div className="node">Medical Insurance</div>} /> */}
            <TreeNode label={<div className="node">Mental Health Support</div>} />
          </TreeNode>
        </TreeNode>
        <TreeNode label={<div className="node">Career Development</div>}>
          <TreeNode label={<div className="node">Skill Building</div>} />
          <TreeNode label={<div className="node">Training Programs</div>} />
        </TreeNode>
        <TreeNode label={<div className="node">Work-Life Balance</div>}>
          <TreeNode label={<div className="node">Flexible Schedules</div>} />
          {/* <TreeNode label={<div className="node">Remote Work Options</div>} /> */}
        </TreeNode>
      </Tree>
    </div>
  );
};

export default Hierarchy;
